__turbopack_context__.v({
  "container": "Wrn39a_container",
});
